import React from "react";
import { Grid, Typography, Box, Button, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { BasicMuiTable, InputControl } from "../../../shared";
import { RemoveCircle } from "@mui/icons-material";

export const VariantSection = ({
  ingredient,
  onChange,
  onVariantAddRemove,
  validator,
}) => {
  const columns = React.useMemo(
    () => [
      {
        header: "Variant Name",
        cell: (row, index) => {
          const helperText = validator.current.message(
            "variant" + index,
            row.name,
            "required"
          );

          return (
            <InputControl
              value={row.name}
              size="small"
              sx={{ width: "300px" }}
              onChange={(e) => onChange(e, index)}
              error={!!helperText}
              helperText={helperText}
            />
          );
        },
      },
      {
        header: "",
        meta: { textAlign: "right", width: "36px" },
        cell: (_, index) => {
          return (
            <IconButton
              size="small"
              sx={{ p: 0, m: 0 }}
              onClick={() => onVariantAddRemove({ row: index })}
            >
              <RemoveCircle color="error" />
            </IconButton>
          );
        },
      },
    ],
    [validator.current]
  );

  return (
    <Grid
      container
      gap="24px"
      py="24px"
      borderBottom="1px solid"
      borderColor="divider"
    >
      <Grid item sm={4}>
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ width: "150px" }}
        >
          Variant
        </Typography>
      </Grid>
      <Grid item flex={1}>
        <Box
          sx={{
            p: "0 8px 8px",
            bgcolor: "background.default",
          }}
        >
          <BasicMuiTable
            data={ingredient?.data?.variants || []}
            columns={columns}
            tableFooter={
              <Button
                type="button"
                size="small"
                variant="text"
                startIcon={<AddIcon />}
                onClick={onVariantAddRemove}
              >
                Add Unit
              </Button>
            }
          />
        </Box>
      </Grid>
    </Grid>
  );
};
